<ng-container *ngIf="!!internalCves; else NoShow">
	<ng-container *ngFor="let cve of internalCves; let i = index">
		<ada-clickable
			[style.display]="'inline-block'"
			[adaClick]="openCveViewer | adaBindMethod: this: cve"
		>
			<ada-text
				content="{{cve}}"
				fontWeight="bold"
				textColor="primary"
			></ada-text>
		</ada-clickable>
		<span *ngIf="i < internalCves.length - 1">,&nbsp;</span>
	</ng-container>
</ng-container>
<ng-template #NoShow>
	<span>--</span>
</ng-template>